import React from 'react';
import { Outlet } from 'react-router';
import Lottie from 'lottie-react';
import { isMobile } from 'react-device-detect';
import { useOfflineNetworkToast } from 'hooks/common';
import { LogoIcon } from 'assets/icons';
import { LeavesAnimation } from 'assets/animations';
import { Toast } from 'components/Toast';
import MobileNotSupported from 'components/MobileNotSupported';
import styles from './LoginLayout.module.css';

const LoginLayout = (): JSX.Element => {
  if (isMobile) return <MobileNotSupported />;
  useOfflineNetworkToast();

  return (
    <React.Fragment>
      <div className={styles.login}>
        <div className={styles.theme} />
        <div className={styles.container}>
          <LogoIcon className={styles.logo} />
          <Outlet />
        </div>
      </div>
      <Lottie animationData={LeavesAnimation} className={styles.animation} />
      <Toast />
    </React.Fragment>
  );
};

export default LoginLayout;
